import React from 'react';

import Header from './Header';

import Topbar from './TopBar';

import Footer from './Footer';

import Wideopage from './Wideopage';

const Wideo = () => {  
    
    return(
        <div>
            <Header/>
            <Topbar/>
            <Wideopage/>
            <Footer/>
           
        </div>
        
    );
};

export default Wideo;